import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=25c2d2d8&"
import script from "./OrgList.vue?vue&type=script&lang=js&"
export * from "./OrgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports